import { useState } from 'react';
import { useShallow } from 'zustand/shallow';

import { InputContext } from 'app/modules/wallforming/components/input-binding/types/inputContext';
import { resolveInputContext } from 'app/modules/wallforming/components/input-binding/utils/inputContextUtils';
import { ArticleTools } from 'app/modules/wallforming/components/scenes/toolbar/content/ArticleTools';
import { HistoryTools } from 'app/modules/wallforming/components/scenes/toolbar/content/HistoryTools';
import { PoiFilterButton } from 'app/modules/wallforming/components/scenes/toolbar/content/PoiFilterButton';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const Toolbar = () => {
    const [menuOpened, setMenuOpened] = useState<boolean>(false);
    const context = usePlacementStore(useShallow(resolveInputContext));

    return (
        <>
            <div className="absolute top-10 left-4 z-12000 rounded-md bg-background-default p-3">
                <div className="flex flex-col items-start justify-start gap-y-2">
                    {/* POI navigation tools */}
                    <div
                        className="flex flex-col items-start justify-start gap-y-2"
                        style={{ display: context === InputContext.Navigation ? 'flex' : 'none' }}
                    >
                        <PoiFilterButton menuOpened={menuOpened} setMenuOpened={setMenuOpened} />
                    </div>

                    {/* Forming tools */}
                    <div
                        className="flex flex-col items-start justify-start gap-y-2"
                        style={{
                            display: context !== InputContext.Navigation && context !== InputContext.View ? 'flex' : 'none'
                        }}
                    >
                        <ArticleTools menuOpened={menuOpened} />
                    </div>

                    <HistoryTools />
                </div>
            </div>
        </>
    );
};
